import { createMemoryHistory } from 'history';
import AtlasSdk from '@atlas/sdk';

import { RoutePathEnum } from '@/routes/constant';

interface INavigationContainerContext {
  path: string;
  search?: string;
  state?: object;
}

export const history = createMemoryHistory();

export const updateAppPath = ({ path, search, state }: INavigationContainerContext) =>
  history.push({ pathname: path.startsWith('/') ? path : `/${path}`, search, state });

export const listenToAtlasPathChange = () => {
  AtlasSdk.navigation.onContainerPathChange((containerContext: INavigationContainerContext) => {
    const { pathname, search } = history.location || {};
    if (
      containerContext.path ||
      (!containerContext.path && (pathname === RoutePathEnum.UNAUTHORIZED || pathname === RoutePathEnum.NOT_FOUND))
    ) {
      updateAppPath(containerContext);
    } else {
      AtlasSdk.navigation.triggerAppPathChange({
        path: pathname,
        search: search,
      });
    }
  });
};

export const listenToUsersPathChange = () => {
  history.listen(({ pathname, search }) => {
    AtlasSdk.navigation.triggerAppPathChange({
      path: pathname,
      search,
    });
  });
};
